import React from "react";
import useFormState from "../useFormState";
import BlockWrapper from "../../Layout/BlockWrapper";
import Control from "../../../../common/Controls/Control";

const RCPROGlobalInfoInputs = ({ company }) => {
  let { actions, errors, inputsConfig, formData } = useFormState();
  const inputState = formData.rcproGlobalInfoInputs;
  const updateRcproData = (e) => {
    const { name, value, type, checked } = e.target;
    const newFields = { [name]: value };
    if (name === "appelSousTraitants" && value == 2) {
      newFields.pourcentageSousTraite = "";
      newFields.imposeRCSousTraitants = "";
    }
    actions.updateRCPROGlobalInfoInputs(newFields);

    //console.log("currentLocation", currentLocation);
  };

  return (
    <>
      <BlockWrapper>
        <div>
          <Control
            label={inputsConfig.principauxClients.label}
            type="checkBtnList"
            name="principauxClients"
            value={inputState.principauxClients}
            change={updateRcproData}
            error={errors}
            labelClassname="w-100"
            inputGroupStyle={{ width: "100%" }}
            btnInline
            datas={inputsConfig.principauxClients.datas}
            dataIndex="id"
            dataLabel="name"
            info={<>Sélectionnez une ou plusieurs options</>}
            required
          />
        </div>
        <div>
          <Control
            label={inputsConfig.appelSousTraitants.label}
            type="btnList"
            name="appelSousTraitants"
            value={inputState.appelSousTraitants}
            change={updateRcproData}
            error={errors}
            labelClassname="w-100"
            inputGroupStyle={{ width: "100%" }}
            btnInline
            datas={inputsConfig.appelSousTraitants.datas}
            dataIndex="id"
            dataLabel="name"
            info={<></>}
            required
          />
        </div>
        {inputState.appelSousTraitants == 1 && (
          <>
            <div>
              <Control
                label={inputsConfig.pourcentageSousTraite.label}
                type="btnList"
                name="pourcentageSousTraite"
                value={inputState.pourcentageSousTraite}
                change={updateRcproData}
                error={errors}
                labelClassname="w-100"
                inputGroupStyle={{ width: "100%" }}
                btnInline
                datas={inputsConfig.pourcentageSousTraite.datas}
                dataIndex="id"
                dataLabel="name"
                info={<></>}
                required
              />
            </div>
            <div>
              <Control
                label={inputsConfig.imposeRCSousTraitants.label}
                type="btnList"
                name="imposeRCSousTraitants"
                value={inputState.imposeRCSousTraitants}
                change={updateRcproData}
                error={errors}
                labelClassname="w-100"
                inputGroupStyle={{ width: "100%" }}
                btnInline
                datas={inputsConfig.imposeRCSousTraitants.datas}
                dataIndex="id"
                dataLabel="name"
                info={<></>}
                required
              />
            </div>
          </>
        )}
      </BlockWrapper>
    </>
  );
};

export default RCPROGlobalInfoInputs;
